// @ts-nocheck
(function () {
  'use strict';

  const STEP_COUNT = 5;
  const STORAGE_KEY = 'birch_profile_draft';

  const STAGE_LABELS = {
    expecting: 'Expecting', newborn: 'Newborn',
    '0_3mo': '0–3 months', '3_6mo': '3–6 months',
    '6_12mo': '6–12 months'
  };
  const HOME_LABELS = {
    apartment: 'Apartment', house: 'House',
    townhouse: 'Townhouse', shared: 'Shared home'
  };
  const TRAVEL_LABELS = {
    rarely: 'Rarely travels', sometimes: 'Travels sometimes', often: 'Travels often'
  };
  // '1' is deliberately absent: "One baby" is the assumption, and a summary
  // card that states the default reads as noise. Mirrors the chip values in
  // sections/profile-setup.liquid and PROFILE_FIELD_VALUES.baby_count_str.
  const BABY_COUNT_LABELS = {
    '2': 'Twins', '3': 'Triplets', '4_plus': 'Four or more babies'
  };
  const TIER_LABELS = {
    best_value: 'Best value', mid_range: 'Mid-range', premium: 'Premium', mix: 'Mix of all'
  };
  const TAG_LABELS = {
    safety_first: 'Safety first', non_toxic: 'Non-toxic materials',
    organic_fabrics: 'Organic fabrics', budget_conscious: 'Budget-conscious',
    premium_quality: 'Premium quality', small_space: 'Small-space friendly',
    easy_to_clean: 'Easy to clean', travel_friendly: 'Travel-friendly',
    long_lasting: 'Long-lasting', eco_conscious: 'Eco-conscious',
    minimalist: 'Minimalist design', smart_features: 'Smart features'
  };
  const FLAG_LABELS = {
    avoid_fragrances: 'Fragrance-free', sensitive_skin: 'Sensitive skin',
    pfas_free: 'PFAS-free', organic_cotton: 'Organic cotton',
    no_wifi_monitors: 'Privacy-first monitors', low_voc: 'Low-VOC',
    bpa_bps_free: 'BPA/BPS-free'
  };

  let currentStep = 1;
  // Server-side metafields are the source of truth. The localStorage draft
  // only carries unsaved in-progress edits and overlays on top.
  let profileData = Object.assign({}, loadServerData(), loadDraft());
  let isSaving = false;
  const hasCompletedProfile = (window.__birchProfileSaved && window.__birchProfileSaved.profile_complete === 'true');

  // ─── DOM refs ────────────────────────────────────────────────────────────
  const steps            = document.querySelectorAll('.bp-step');
  const panels           = document.querySelectorAll('.bp-panel');
  const stepTabs         = document.querySelectorAll('.bp-step-tab');
  const navEl            = document.getElementById('bp-nav');
  const backBtn          = document.getElementById('bp-back');
  const continueBtn      = document.getElementById('bp-continue');
  const saveLaterBtn     = document.getElementById('bp-save-later');
  const startBtn         = document.getElementById('bp-start');
  const skipAllBtn       = document.getElementById('bp-skip-all');
  const metaContainer    = document.getElementById('bp-metafields-container');

  // ─── Init ────────────────────────────────────────────────────────────────
  function init() {
    if (!steps.length) return;

    wireChips();
    wireToggles();
    wireDateAndSelect();
    wireBabyStageConditional();
    wireButtons();
    restoreFromDraft();
    // ?edit=1 (pencil icon) OR already-completed profile → open at Baby step (2)
    // so the user lands directly on pre-filled editable fields.
    // NOTE: no in-theme link passes ?edit=1 anymore — editing preferences now
    // goes to the flat sections/profile-settings.liquid page instead. Left in
    // place as inert dead code rather than ripped out, so this wizard (still
    // the real first-time onboarding flow) isn't touched for pure cleanup.
    var isEditMode = new URLSearchParams(window.location.search).get('edit') === '1';
    var initialStep = (isEditMode || hasCompletedProfile) ? 2 : 1;
    currentStep = initialStep;
    showStep(initialStep);
    // Make step bubbles directly clickable when the profile is already set
    if (isEditMode || hasCompletedProfile) wireStepTabNavigation();
  }

  // ─── Load server-side saved metafields ───────────────────────────────────
  function loadServerData() {
    var src = window.__birchProfileSaved;
    if (!src || typeof src !== 'object') return {};
    var out = {};
    Object.keys(src).forEach(function (k) {
      var v = src[k];
      if (v === null || v === undefined || v === '') return;
      if (Array.isArray(v) && v.length === 0) return;
      if (typeof v === 'object' && !Array.isArray(v) && Object.keys(v).length === 0) return;
      out[k] = v;
    });
    return out;
  }

  // ─── Chip selectors ──────────────────────────────────────────────────────
  function wireChips() {
    document.querySelectorAll('.bp-chips').forEach(function (chipsEl) {
      var isMulti = chipsEl.dataset.type === 'multi';
      var max = parseInt(chipsEl.dataset.max, 10) || Infinity;

      chipsEl.querySelectorAll('.bp-chip').forEach(function (chip) {
        chip.addEventListener('click', function () {
          if (isMulti) {
            var sel = chipsEl.querySelectorAll('.bp-chip--selected');
            if (!chip.classList.contains('bp-chip--selected') && sel.length >= max) return;
            chip.classList.toggle('bp-chip--selected');
          } else {
            chipsEl.querySelectorAll('.bp-chip').forEach(function (c) {
              c.classList.remove('bp-chip--selected');
            });
            chip.classList.add('bp-chip--selected');
          }
          collectChips(chipsEl);
          updateLivePreview();
        });
      });
    });
  }

  function collectChips(chipsEl) {
    var field   = chipsEl.dataset.field;
    var isMulti = chipsEl.dataset.type === 'multi';
    var selected = chipsEl.querySelectorAll('.bp-chip--selected');
    profileData[field] = isMulti
      ? Array.from(selected).map(function (c) { return c.dataset.value; })
      : (selected.length ? selected[0].dataset.value : null);
    saveDraft();
  }

  // ─── Toggles ─────────────────────────────────────────────────────────────
  function wireToggles() {
    document.querySelectorAll('.bp-toggle input[type="checkbox"]').forEach(function (tog) {
      tog.addEventListener('change', function () {
        if (!profileData.safety_flags) profileData.safety_flags = {};
        profileData.safety_flags[tog.dataset.field] = tog.checked;
        saveDraft();
      });
    });
  }

  // ─── Date / select inputs ────────────────────────────────────────────────
  function wireDateAndSelect() {
    document.querySelectorAll('input[type="date"][data-field]').forEach(function (el) {
      el.addEventListener('change', function () {
        profileData[el.dataset.field] = el.value;
        saveDraft();
        updateLivePreview();
      });
    });

    document.querySelectorAll('select[data-field]').forEach(function (el) {
      el.addEventListener('change', function () {
        profileData[el.dataset.field] = el.value;
        saveDraft();
        updateLivePreview();
      });
    });
  }

  // ─── Baby stage → show/hide date field ──────────────────────────────────
  function wireBabyStageConditional() {
    var stageChips = document.querySelector('[data-field="baby_stage"]');
    if (!stageChips) return;

    stageChips.querySelectorAll('.bp-chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var dueDateField = document.getElementById('bp-due-date-field');
        var dobField     = document.getElementById('bp-dob-field');
        if (!dueDateField || !dobField) return;

        var budgetField = document.getElementById('bp-budget-range-field');
        if (chip.dataset.value === 'expecting') {
          dueDateField.style.display = '';
          dobField.style.display = 'none';
          if (budgetField) budgetField.style.display = '';
        } else if (['newborn', '0_3mo', '3_6mo', '6_12mo'].includes(chip.dataset.value)) {
          dueDateField.style.display = 'none';
          dobField.style.display = '';
          if (budgetField) budgetField.style.display = 'none';
        } else {
          dueDateField.style.display = 'none';
          dobField.style.display = 'none';
          if (budgetField) budgetField.style.display = 'none';
        }
      });
    });
  }

  // ─── Step bubble direct navigation (edit / completed profile only) ────────
  function wireStepTabNavigation() {
    stepTabs.forEach(function (tab) {
      var target = parseInt(tab.dataset.goto, 10);
      if (!target) return;
      tab.classList.add('bp-step-tab--nav');
      tab.addEventListener('click', function () {
        goToStep(target);
      });
    });
  }

  // ─── Return-to destination ───────────────────────────────────────────────
  // When the user arrives via ?return_to= (e.g. from the registry-edit nudge),
  // send them back there once their profile is complete instead of the default
  // CTAs. Same-origin internal paths only — guards against open redirects.
  function getReturnTo() {
    var raw = new URLSearchParams(window.location.search).get('return_to');
    if (!raw) return null;
    // Must be a root-relative path; reject "//host", "http://…", "javascript:" etc.
    if (raw.charAt(0) !== '/' || raw.charAt(1) === '/') return null;
    return raw;
  }

  // ─── Button wiring ───────────────────────────────────────────────────────
  function wireButtons() {
    var returnTo = getReturnTo();
    if (startBtn)   startBtn.addEventListener('click', function () { goToStep(2); });
    if (skipAllBtn) skipAllBtn.addEventListener('click', function () { window.location.href = '/'; });
    if (backBtn)    backBtn.addEventListener('click', function () { goToStep(currentStep - 1); });

    if (continueBtn) continueBtn.addEventListener('click', function () {
      if (currentStep < STEP_COUNT) {
        var next = currentStep + 1;
        submitProfile(); // save in background, don't block navigation
        goToStep(next);
      }
    });

    if (saveLaterBtn) saveLaterBtn.addEventListener('click', function () {
      var dest = returnTo || '/pages/account-dashboard';
      submitProfile(function () { window.location.href = dest; });
    });

    var goRegistry = document.getElementById('bp-go-registry');
    var goShop     = document.getElementById('bp-go-shop');
    if (goRegistry) {
      // Came from the registry-edit nudge → finish the profile and head straight
      // back to that registry instead of the default "Create my registry" flow.
      if (returnTo) goRegistry.textContent = 'Back to your registry';
      goRegistry.addEventListener('click', function (e) {
        e.preventDefault();
        var href = returnTo || goRegistry.getAttribute('href');
        submitProfile(function () { window.location.href = href; });
      });
    }
    if (goShop) {
      goShop.addEventListener('click', function (e) {
        e.preventDefault();
        var href = goShop.getAttribute('href');
        submitProfile(function () { window.location.href = href; });
      });
    }

    var editBtn = document.getElementById('bp-edit-profile');
    if (editBtn) editBtn.addEventListener('click', function () { goToStep(2); });

    document.addEventListener('click', function (e) {
      var editLink = e.target.closest('[data-edit-step]');
      if (editLink) goToStep(parseInt(editLink.dataset.editStep, 10));
    });
  }

  // ─── Step navigation ─────────────────────────────────────────────────────
  function goToStep(n) {
    if (n < 1 || n > STEP_COUNT) return;
    currentStep = n;
    if (n === STEP_COUNT) buildSummary();
    showStep(n);
    saveDraft();
  }

  function showStep(n) {
    steps.forEach(function (step) {
      step.classList.toggle('bp-step--active', parseInt(step.dataset.step, 10) === n);
    });
    panels.forEach(function (panel) {
      panel.classList.toggle('bp-panel--active', parseInt(panel.dataset.panel, 10) === n);
    });
    stepTabs.forEach(function (tab) {
      var tn = parseInt(tab.dataset.goto, 10);
      tab.classList.toggle('bp-step-tab--active', tn === n);
      tab.classList.toggle('bp-step-tab--completed', tn < n);
    });

    if (navEl) navEl.classList.toggle('bp-nav--visible', n > 1);
    if (continueBtn) continueBtn.style.display = (n === STEP_COUNT) ? 'none' : '';
    if (backBtn)     backBtn.style.display = (n <= 1) ? 'none' : '';
    if (saveLaterBtn) {
      saveLaterBtn.textContent = (n === STEP_COUNT) ? 'Save & finish later' : 'Save for later';
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // ─── Live preview (step 4 panel) ─────────────────────────────────────────
  function updateLivePreview() {
    var preview = document.getElementById('bp-live-preview');
    if (!preview) return;

    var lines = [];

    if (profileData.baby_stage === 'expecting' && profileData.due_date) {
      var d = new Date(profileData.due_date + 'T00:00:00');
      lines.push('Expecting in ' + d.toLocaleString('default', { month: 'long', year: 'numeric' }));
    } else if (profileData.baby_stage && STAGE_LABELS[profileData.baby_stage]) {
      lines.push(STAGE_LABELS[profileData.baby_stage]);
    }

    if (profileData.home_type && HOME_LABELS[profileData.home_type]) lines.push(HOME_LABELS[profileData.home_type]);
    if (profileData.travel_freq && TRAVEL_LABELS[profileData.travel_freq])  lines.push(TRAVEL_LABELS[profileData.travel_freq]);
    if (profileData.priority_tags && profileData.priority_tags.length) {
      lines.push(profileData.priority_tags.map(function (t) { return TAG_LABELS[t] || t; }).join(' · '));
    }

    if (lines.length === 0) {
      preview.innerHTML = '<p class="bp-live-preview__empty">Your answers will appear here as you complete each step.</p>';
    } else {
      preview.innerHTML = lines.map(function (l) {
        return '<p class="bp-live-preview__line">' + escHtml(l) + '</p>';
      }).join('');
    }
  }

  // ─── Build summary (final step) ──────────────────────────────────────────
  function buildSummary() {
    var summary = document.getElementById('bp-summary');
    if (!summary) return;

    var sections = [];

    var babyLines = [];
    if (profileData.baby_stage === 'expecting' && profileData.due_date) {
      var d = new Date(profileData.due_date + 'T00:00:00');
      babyLines.push('Due ' + d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }));
    } else if (profileData.baby_stage && STAGE_LABELS[profileData.baby_stage]) {
      babyLines.push(STAGE_LABELS[profileData.baby_stage]);
    }
    if (profileData.is_first_baby === 'true') babyLines.push('First baby');
    if (BABY_COUNT_LABELS[profileData.baby_count_str]) babyLines.push(BABY_COUNT_LABELS[profileData.baby_count_str]);
    if (babyLines.length) sections.push({ title: 'Baby timeline', lines: babyLines, step: 2 });

    var homeLines = [];
    if (profileData.home_type && HOME_LABELS[profileData.home_type]) homeLines.push(HOME_LABELS[profileData.home_type]);
    if (profileData.travel_freq && TRAVEL_LABELS[profileData.travel_freq]) homeLines.push(TRAVEL_LABELS[profileData.travel_freq]);
    if (homeLines.length) sections.push({ title: 'Home', lines: homeLines, step: 3 });

    if (profileData.priority_tags && profileData.priority_tags.length) {
      sections.push({
        title: 'Priorities',
        lines: [profileData.priority_tags.map(function (t) { return TAG_LABELS[t] || t; }).join(' · ')],
        step: 4
      });
    }

    var budgetLines = [];
    if (profileData.price_tier && TIER_LABELS[profileData.price_tier]) budgetLines.push(TIER_LABELS[profileData.price_tier] + ' overall');
    if (profileData.splurge_cats && profileData.splurge_cats.length)   budgetLines.push('Splurge: ' + profileData.splurge_cats.join(', '));
    if (budgetLines.length) sections.push({ title: 'Budget', lines: budgetLines, step: 4 });

    if (sections.length === 0) {
      summary.innerHTML = '<p class="bp-summary__empty">No answers saved yet — <button class="bp-btn bp-btn--ghost" data-edit-step="2">start from the beginning</button></p>';
      return;
    }

    summary.innerHTML = sections.map(function (s) {
      return [
        '<div class="bp-summary-card">',
          '<div class="bp-summary-card__head">',
            '<p class="bp-summary-card__title">' + escHtml(s.title) + '</p>',
            '<button class="bp-summary-card__edit" data-edit-step="' + s.step + '">Edit</button>',
          '</div>',
          s.lines.map(function (l) { return '<p class="bp-summary-card__line">' + escHtml(l) + '</p>'; }).join(''),
        '</div>'
      ].join('');
    }).join('');
  }

  // ─── Build metafields payload ─────────────────────────────────────────────
  function buildMetafields() {
    var mf  = [];
    var idx = 0;

    function add(key, value, type) {
      if (value === null || value === undefined || value === '') return;
      mf.push({ idx: idx++, key: key, value: String(value), type: type || 'single_line_text_field' });
    }

    add('baby_stage',        profileData.baby_stage);
    add('due_date',          profileData.due_date);
    add('baby_dob',          profileData.baby_dob);
    add('is_first_baby',     profileData.is_first_baby);
    // CANONICAL KEY. This used to write `baby_count`, while every reader — the
    // AI worker's CustomerProfile, update_profile_fact, every multiples rule —
    // looked at `baby_count_str`, so the wizard's answer never reached the
    // registry builder. The worker also reads the old key as a fallback, so
    // profiles saved before this fix keep working; nothing needs migrating.
    add('baby_count_str',    profileData.baby_count_str !== 'prefer_not' ? profileData.baby_count_str : null);
    add('registry_occasion', profileData.registry_occasion);

    add('home_type',     profileData.home_type);
    add('space_size',    profileData.space_size);
    add('has_stairs',    profileData.has_stairs);
    add('has_elevator',  profileData.has_elevator);
    add('car_count',     profileData.car_count);
    add('travel_freq',   profileData.travel_freq);
    add('laundry_access',profileData.laundry_access);
    add('has_siblings',  profileData.has_siblings);
    add('has_pets',      profileData.has_pets);

    if (profileData.priority_tags && profileData.priority_tags.length) {
      add('priority_tags', JSON.stringify(profileData.priority_tags), 'json');
    }
    add('price_tier',   profileData.price_tier);
    add('budget_range', profileData.budget_range);
    if (profileData.splurge_cats && profileData.splurge_cats.length) {
      add('splurge_cats', JSON.stringify(profileData.splurge_cats), 'json');
    }
    if (profileData.safety_flags && Object.keys(profileData.safety_flags).length) {
      add('safety_flags', JSON.stringify(profileData.safety_flags), 'json');
    }

    add('profile_complete',   currentStep === STEP_COUNT ? 'true' : 'false');
    add('profile_updated_at', new Date().toISOString());

    return mf;
  }

  // ─── Submit via Admin API proxy (required for New Customer Accounts) ───────
  // The classic /account PUT endpoint is disabled for New Customer Accounts stores.
  // We POST to a Cloudflare Worker that calls the Shopify Admin API instead.
  // Host-aware: prod storefront → prod profile worker; local dev → the LOCAL
  // birch-profile worker (:8789, which sends CORS '*') so saves never touch
  // production customer data. Override with ?profile_api= , localStorage
  // 'birch_profile_api', or window.BIRCH_PROFILE_API (e.g. the staging worker,
  // https://birch-profile.api-staging.birchstore.com/save-profile).
  var PROFILE_API_URL = (function () {
    var h = window.location.hostname;
    if (h === 'localhost' || h === '127.0.0.1') {
      try {
        var ov = new URLSearchParams(window.location.search).get('profile_api')
          || (window.localStorage && localStorage.getItem('birch_profile_api'))
          || window.BIRCH_PROFILE_API;
        if (ov) return ov;
      } catch (_) { /* no-op */ }
      return 'http://localhost:8789/save-profile';
    }
    // Route through the Shopify App Proxy (same-origin) so Shopify signs the
    // request + injects logged_in_customer_id — the worker derives the customer
    // from that signed id, NOT from the body. (Direct workers.dev calls are now
    // rejected: they're unsigned.) Requires the birch-profile app's App Proxy to
    // be installed (see shopify.app.toml [app_proxy]).
    return '/apps/birch-profile/save-profile';
  })();

  function submitProfile(callback) {
    var isExplicitSave = typeof callback === 'function';
    if (isExplicitSave && isSaving) return;
    if (isExplicitSave) isSaving = true;

    var btns = document.querySelectorAll('#bp-go-registry, #bp-go-shop, #bp-save-later');
    if (isExplicitSave) btns.forEach(function (b) { b.disabled = true; b.style.opacity = '0.6'; });

    var customerId = window.__birchCustomerId;
    if (!customerId) {
      showSaveError('Not signed in — please refresh and try again.');
      if (isExplicitSave) { isSaving = false; btns.forEach(function(b){ b.disabled=false; b.style.opacity=''; }); }
      return;
    }

    fetch(PROFILE_API_URL, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({
        customer_id: customerId,
        metafields:  buildMetafields()
      })
    })
    .then(function (res) {
      if (res.ok) {
        try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
        if (isExplicitSave && typeof callback === 'function') callback();
      } else {
        res.text().then(function(t){ console.error('Save error body:', t); });
        showSaveError('Save failed (' + res.status + '). Please try again.');
      }
    })
    .catch(function (err) {
      console.error('Profile save error:', err);
      showSaveError('Could not connect — please check your internet and try again.');
    })
    .finally(function () {
      if (isExplicitSave) {
        isSaving = false;
        btns.forEach(function (b) { b.disabled = false; b.style.opacity = ''; });
      }
    });
  }

  // ─── Draft persistence ───────────────────────────────────────────────────
  function saveDraft() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ step: currentStep, data: profileData }));
    } catch (e) {}
  }

  function loadDraft() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (raw) return JSON.parse(raw).data || {};
    } catch (e) {}
    return {};
  }

  function restoreFromDraft() {
    if (!profileData || !Object.keys(profileData).length) return;

    document.querySelectorAll('.bp-chips').forEach(function (chipsEl) {
      var field   = chipsEl.dataset.field;
      var isMulti = chipsEl.dataset.type === 'multi';
      var saved   = profileData[field];
      if (!saved) return;
      chipsEl.querySelectorAll('.bp-chip').forEach(function (chip) {
        var match = isMulti
          ? (Array.isArray(saved) && saved.includes(chip.dataset.value))
          : (chip.dataset.value === saved);
        chip.classList.toggle('bp-chip--selected', match);
      });
    });

    document.querySelectorAll('input[type="date"][data-field]').forEach(function (el) {
      if (profileData[el.dataset.field]) el.value = profileData[el.dataset.field];
    });
    document.querySelectorAll('select[data-field]').forEach(function (el) {
      if (profileData[el.dataset.field]) el.value = profileData[el.dataset.field];
    });
    document.querySelectorAll('.bp-toggle input[type="checkbox"][data-field]').forEach(function (tog) {
      var flags = profileData.safety_flags || {};
      tog.checked = !!flags[tog.dataset.field];
    });

    var savedStage = profileData.baby_stage;
    if (savedStage) {
      var dueDateField  = document.getElementById('bp-due-date-field');
      var dobField      = document.getElementById('bp-dob-field');
      var budgetField   = document.getElementById('bp-budget-range-field');
      if (dueDateField && dobField) {
        if (savedStage === 'expecting') {
          dueDateField.style.display = '';
          dobField.style.display = 'none';
          if (budgetField) budgetField.style.display = '';
        } else if (['newborn', '0_3mo', '3_6mo', '6_12mo'].includes(savedStage)) {
          dueDateField.style.display = 'none';
          dobField.style.display = '';
          if (budgetField) budgetField.style.display = 'none';
        }
      }
    }

    updateLivePreview();
  }

  // ─── Save error banner ───────────────────────────────────────────────────
  function showSaveError(msg) {
    var existing = document.getElementById('bp-save-error');
    if (existing) existing.remove();
    var el = document.createElement('div');
    el.id = 'bp-save-error';
    el.style.cssText = 'position:fixed;bottom:1.5rem;left:50%;transform:translateX(-50%);background:#7a2020;color:#fff;padding:0.75rem 1.5rem;border-radius:99px;font-size:0.875rem;font-weight:500;z-index:9999;box-shadow:0 4px 20px rgba(0,0,0,0.2);max-width:90vw;text-align:center;';
    el.textContent = msg;
    document.body.appendChild(el);
    setTimeout(function () { if (el.parentNode) el.remove(); }, 6000);
  }

  // ─── Utilities ───────────────────────────────────────────────────────────
  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  window.birchProfile = { goToStep: goToStep };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
